import React from 'react';
import styles from './DrugClassIcon.module.scss';
import { getLang } from 'shared/store/selectors/lang.selector';
import { useSelector } from 'react-redux';
import { getDrugClassIcon } from '../../../constants/drugClassIconsMapper';
import { IconButton } from 'src/components/design-system';

export function DrugClassIcon({ drugClass, tooltip = true }) {
  const DrugClass = getDrugClassIcon(drugClass);

  const label = useSelector(getLang('DRUG_CLASSES'))[drugClass];

  return (
    <IconButton label={label} showTooltip={tooltip}>
      <img src={DrugClass} alt="" className={styles.drugClassIcon} />
    </IconButton>
  );
}
